import { render, staticRenderFns } from "./MyPolicies.vue?vue&type=template&id=40a3be82"
import script from "./MyPolicies.vue?vue&type=script&lang=js"
export * from "./MyPolicies.vue?vue&type=script&lang=js"
import style0 from "./MyPolicies.vue?vue&type=style&index=0&id=40a3be82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports